import styles from './Expertise.module.css';
import { motion } from 'framer-motion';

const Expertise = () => {
  return (
    <div className={styles.expertise}>
      <motion.h1 animate={{ y: 10 }} className={styles.expertise_title}>
        Kunskaper CV
      </motion.h1>
      <hr className={styles.hr_expertise_hr}></hr>
      <div>
        <p className={styles.expertise_para}>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin
          condimentum libero vel nisl tristique euismod. In convallis sed eros
          vehicula vehicula. Nam vitae neque id est rutrum interdum sit amet nec
          ligula. Pellentesque habitant morbi tristique senectus et netus et
          malesuada fames ac turpis egestas. Morbi quis bibendum ex. Etiam eu
          magna est. Aliquam vel fermentum est. Curabitur rutrum lobortis nulla,
          vitae porta lacus egestas a. Quisque gravida fermentum tellus ut
          laoreet. Quisque sit amet tortor tortor. Etiam tincidunt nunc eu
          ligula euismod egestas. Maecenas vel tempus est. Pellentesque
          suscipit, arcu sed egestas semper, neque felis tristique augue, vitae
          elementum erat tellus eget enim. Sed luctus sapien a nisi ultrices,
          nec auctor odio porttitor.
        </p>
      </div>
    </div>
  );
};

export default Expertise;
